import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import OrganizationFilter from '../../components/OrganizationFilter';
import OrganizationPicker from '../../components/OrganizationPicker';
import LabeledSelectionCheckbox from '../../components/LabeledSelectionCheckbox';
import { ventrisConfig } from '../../ventris.config';
import { focusFirstInvalidField } from '../../accessibility/focus';

import StudentPageIcon from '../../icons/StudentPageIcon';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import StudentIcon from '../../icons/StudentIcon';
import { getUseCaseTerminology } from '../../useCase';
import { launchableAssessmentsForUser } from '../../assessmentAccess';

type ClinicianStudentsProps = {
};

let searchDebounce: any = null;

function ClinicianStudents({}: ClinicianStudentsProps) {
  const terms = getUseCaseTerminology();
  const location = useLocation();
  const navigate = useNavigate();
  const hierarchyEditHandled = useRef(false);
  const [user, setUser] = useState([] as any);
  const [organizations, setOrganizations] = useState([] as any);
  const [students, setStudents] = useState([] as any);
  const [selectedStudent, setSelectedStudent] = useState({} as any);
  const [selectedStudentId, setSelectedStudentId] = useState("" as any);
  const [selectedStudentIds, setSelectedStudentIds] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [errorCreate, setErrorCreate] = useState("");
  const [validatedCreate, setValidatedCreate] = useState(false);
  const [errorUpload, setErrorUpload] = useState("");
  const [uploadSummary, setUploadSummary] = useState("");
  const [validatedUpload, setValidatedUpload] = useState(false);
  const [defaultGrade, setDefaultGrade] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [grade, setGrade] = useState("");
  const [birthdate, setBirthdate] = useState(Date.now() as any);
  const [organizationId, setOrganizationId] = useState("");
  const [studentCode, setStudentCode] = useState("");
  const [uploadOrganizationId, setUploadOrganizationId] = useState("");
  const [uploadFile, setUploadFile] = useState(null as File | null);

  const [student, setStudent] = useState("" as any);
  const [test, setTest] = useState(3 as any);
  const [launchTestAfterSave, setLaunchTestAfterSave] = useState(false);
  const [showLaunchTest, setShowLaunchTest] = useState(false);
  const [organizationsLoaded, setOrganizationsLoaded] = useState(false);

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [search, setSearch] = useState("");

  const editFormRef = useRef(null as any);
  const createFormRef = useRef(null as any);
  const uploadFormRef = useRef(null as any);

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    let currentUser = sessionStorage.getItem("current_user");
    const parsedUser = JSON.parse(currentUser!);
    setUser(parsedUser);
    setOrganizationId(parsedUser.organization_id);
    const firstAssessment = launchableAssessmentsForUser(parsedUser)[0];
    if (firstAssessment) setTest(firstAssessment.schemaId);
    
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
      setOrganizationsLoaded(true);
      loadStudents(1);
    });
  }, []);

  useEffect(() => {
      loadStudents(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, archivedFilter]);
  
    useEffect(() => {
      if (searchDebounce) {
        clearTimeout(searchDebounce);
      }
  
      searchDebounce = setTimeout(() => {
        setPage(1);
        loadStudents(1);
      }, 500);
    }, [search]);

  const loadStudents = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/students?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&archived=' + archivedFilter + '&search=' + search, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setStudents(data.students);
        setTotalSize(data.total_records);
      });
    },
    100);
  }
  const loadStudent = (studentId: any) => {
    document.location.href = "/student/" + studentId;
  }

  const editStudent = (student: any) => {
    setSelectedStudent(student);
    setSelectedStudentId(student.id);
    setFirstName(student.first_name);
    setLastName(student.last_name);
    setGrade(student.grade);
    setBirthdate(student.birthdate);
    setOrganizationId(student.organization_id);
    setStudentCode(student.student_code);
    setShowEditModal(true);
  }

  useEffect(() => {
    const hierarchyStudent = (location.state as any)?.editStudent;
    if (hierarchyEditHandled.current || !hierarchyStudent) {
      return;
    }

    hierarchyEditHandled.current = true;
    const token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + "/api/student/" + hierarchyStudent.id, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        editStudent(data.success ? { ...hierarchyStudent, ...data.student } : hierarchyStudent);
        navigate(location.pathname, { replace: true, state: null });
      });
  }, [location.pathname, location.state, navigate]);

  const handleEditSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedEdit(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedEdit(true);
        setErrorEdit("");

        if (defaultGrade) {
          localStorage.setItem('default_grade', grade);
        }
        setDefaultGrade(false);

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/student/' + selectedStudent.id, {
          method: 'put',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            first_name: firstName,
            last_name: lastName,
            grade: grade,
            birthdate: birthdate,
            student_code: studentCode,
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowEditModal(false);
            setPage(1);
            loadStudents(1);
            if (launchTestAfterSave) {
              setStudent(data.student?.id);
              setShowLaunchTest(true);
              setLaunchTestAfterSave(false);
            }
          } else {
            setErrorEdit("An error occured while editing this student. Please try again!");
          }
        });
    }
  };

  const createStudent = () => {
    const defaultOrganizationId = availableManualOrganizations.find((organization: any) => String(organization.id) === String(user.organization_id))?.id
      ?? availableManualOrganizations[0]?.id
      ?? "";

    const savedDefaultGrade = localStorage.getItem('default_grade');
    setSelectedStudent({});
    setSelectedStudentId(-1);
    setFirstName("");
    setLastName("");
    setGrade(savedDefaultGrade ?? "PK");
    setBirthdate(Date.now());
    setOrganizationId(defaultOrganizationId);
    setStudentCode("");
    setShowCreateModal(true);
  }

  const createCsvTemplate = () => {
    return "First Name,Last Name,Grade,Birthdate,Student Code\n";
  };

  const handleDownloadTemplate = () => {
    const csvContent = createCsvTemplate();
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "students_template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const parseCsv = (content: string) => {
    const rows: string[][] = [];
    let currentRow: string[] = [];
    let currentField = "";
    let inQuotes = false;

    for (let i = 0; i < content.length; i++) {
      const char = content[i];
      const nextChar = content[i + 1];

      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          currentField += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === "," && !inQuotes) {
        currentRow.push(currentField);
        currentField = "";
      } else if ((char === "\n" || char === "\r") && !inQuotes) {
        if (char === "\r" && nextChar === "\n") {
          i++;
        }
        currentRow.push(currentField);
        if (currentRow.some((field) => field.trim() !== "")) {
          rows.push(currentRow);
        }
        currentRow = [];
        currentField = "";
      } else {
        currentField += char;
      }
    }

    currentRow.push(currentField);
    if (currentRow.some((field) => field.trim() !== "")) {
      rows.push(currentRow);
    }

    return rows;
  };

  const normalizeHeader = (header: string) => header.trim().toLowerCase();

  const openUploadStudents = () => {
    const defaultOrganizationId = availableManualOrganizations.find((organization: any) => String(organization.id) === String(user.organization_id))?.id
      ?? availableManualOrganizations[0]?.id
      ?? "";

    setValidatedUpload(false);
    setErrorUpload("");
    setUploadSummary("");
    setUploadOrganizationId(defaultOrganizationId);
    setUploadFile(null);
    setShowUploadModal(true);
  };

  const handleCreateSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedCreate(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedCreate(true);
        setErrorCreate("");

        if (defaultGrade) {
          localStorage.setItem('default_grade', grade);
        }
        setDefaultGrade(false);

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/student', {
          method: 'post',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            first_name: firstName,
            last_name: lastName,
            grade: grade,
            birthdate: birthdate,
            student_code: studentCode,
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowCreateModal(false);
            setPage(1);
            loadStudents(1);
            if (launchTestAfterSave) {
              setStudent(data.student?.id);
              setShowLaunchTest(true);
              setLaunchTestAfterSave(false);
            }
          } else {
            setErrorCreate("An error occured while creating this student. Please ensure that you are using a unique student code and try again!");
          }
        });
    }
  };

  const handleUploadSubmit = async (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false || !uploadFile) {
      setValidatedUpload(true);
      if (!uploadFile) {
        setErrorUpload("Please select a CSV file.");
      }
      focusFirstInvalidField(form);
      return;
    }

    setValidatedUpload(true);
    setErrorUpload("");
    setUploadSummary("");

    const requiredHeaders = ["first name", "last name", "grade", "birthdate", "student code"];
    const token = sessionStorage.getItem("token");

    try {
      const csvContent = await uploadFile.text();
      const rows = parseCsv(csvContent);
      if (rows.length < 2) {
        setErrorUpload("CSV must include a header row and at least one data row.");
        return;
      }

      const headerRow = rows[0].map((value) => normalizeHeader(value));
      const missingHeaders = requiredHeaders.filter((header) => !headerRow.includes(header));
      if (missingHeaders.length > 0) {
        setErrorUpload("CSV is missing required columns: " + missingHeaders.join(", "));
        return;
      }

      const firstNameIndex = headerRow.indexOf("first name");
      const lastNameIndex = headerRow.indexOf("last name");
      const gradeIndex = headerRow.indexOf("grade");
      const birthdateIndex = headerRow.indexOf("birthdate");
      const studentCodeIndex = headerRow.indexOf("student code");

      const payloadRows = rows.slice(1).map((row) => {
        return {
          organization_id: uploadOrganizationId,
          first_name: (row[firstNameIndex] || "").trim(),
          last_name: (row[lastNameIndex] || "").trim(),
          grade: (row[gradeIndex] || "").trim(),
          birthdate: (row[birthdateIndex] || "").trim(),
          student_code: (row[studentCodeIndex] || "").trim(),
        };
      });

      if (payloadRows.length === 0) {
        setErrorUpload("CSV must include at least one data row.");
        return;
      }

      const response = await fetch(ventrisConfig.url + '/api/students/bulk', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({
          students: payloadRows
        })
      });
      const data = await response.json();

      const successCount = data.created_count || 0;
      const failedCount = data.failed_count || 0;
      const failedRows = Array.isArray(data.failed) ? data.failed : [];
      const rowErrors = failedRows.slice(0, 10).map((failure: any) => {
        const rowNumber = Number(failure.index) + 2;
        return "Row " + rowNumber + ": " + (failure.message || "API rejected this student.");
      });

      setUploadSummary("Upload complete. Added " + successCount + " student(s), failed " + failedCount + " row(s).");
      if (rowErrors.length > 0) {
        setErrorUpload(rowErrors.join(" "));
      }

      setPage(1);
      loadStudents(1);
    } catch (err) {
      setErrorUpload("Failed to parse or upload CSV. Please verify the file and try again.");
    }
  };

  const actuallyDeleteStudents = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/student/delete', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        students: selectedStudentIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      fetch(ventrisConfig.url + '/api/students', {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
        }).then(async function (data) {
        setShowDeleteModal(false);
        setShowArchiveModal(false);
        setPage(1);
        loadStudents(1);
      });
    });
  }

  const actuallyArchiveStudents = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/student/' + (archivedFilter === 'true' ? 'unarchive' : 'archive'), {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        students: selectedStudentIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadStudents(1);
    });
  }

  const startNewTest = () => {
    const id = Number(test);
    const assessment = launchableAssessmentsForUser(user).find((option) => option.schemaId === id);
    if (!assessment) return;
    const name = assessment.name;

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: name,
        status: "Incomplete",
        test_schema_id: id,
        organization_id: user.organization_id,
        student_id: student,
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      if (data.success && data.test?.id) {
        document.location.href = "/test/" + name + "/" + data.test.id;
        return;
      }

      alert(data.message || "Unable to start a new test.");
    });
  }

  const toggleSelectedStudent = (studentId: string | number) => {
    const normalizedId = String(studentId);
    setSelectedStudentIds((prev: any) =>
      prev.includes(normalizedId)
        ? prev.filter((item: any) => item !== normalizedId)
        : [...prev, normalizedId]
    );
  }

  const checkboxFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
    const { selectedStudentIds, toggleSelectedStudent } = formatExtraData;
    return <LabeledSelectionCheckbox
      id={`student-select-${row.id}`}
      label={`Select ${row.first_name} ${row.last_name}`}
      checked={selectedStudentIds.includes(String(row.id))}
      onChange={() => toggleSelectedStudent(row.id)}
    />;
  }

  const studentNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <span aria-hidden="true" className={row.archived ? "ventris-table-status-archived" : "ventris-table-status-completed"}></span>
        <span className="visually-hidden">{row.archived ? "Archived: " : "Active: "}</span>
        <Button variant="link" size="sm" onClick={() => loadStudent(row.id)}>{cell}</Button>
      </div>
    );
  }

  const actionFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => editStudent(row)} disabled={!!row.schoolday_managed}>Edit</Button>
      </div>
    );
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Select',
      headerFormatter: () => <span className="visually-hidden">Select students</span>,
      formatter: checkboxFormatter,
      formatExtraData: { selectedStudentIds, toggleSelectedStudent }
    },
    {
      dataField: 'student_code',
      text: `${terms.student} Code`,
      sort: true,
      formatter: studentNameFormatter
    },
    {
      dataField: 'last_name',
      text: 'Last Name',
      sort: true
    },
    {
      dataField: 'first_name',
      text: 'First Name',
      sort: true
    },
    {
      dataField: 'grade',
      text: 'Grade',
      sort: true
    },
    {
      dataField: 'birthdate',
      text: 'Birthdate',
      sort: true
    },
    {
      dataField: 'organization',
      text: 'Organization',
      sort: true
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: actionFormatter
    }
  ];

  const handleTabChange = (tabKey: string | null) => {
    if (tabKey === 'view-all') {
      setArchivedFilter("");
    } else if (tabKey === 'active') {
      setArchivedFilter("false");
    } else if (tabKey === 'archived') {
      setArchivedFilter("true");
    }
    setPage(1);
  }

  const updateFilter = (organizations: any) => {
    setOrganizationFilter(organizations.join('|'));
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setPage(page);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  const availableManualOrganizations = organizations.filter((organization: any) => !organization.schoolday_managed);
  const canManageStudentsManually = availableManualOrganizations.length > 0;
  const selectedManagedStudents = students.filter((student: any) => selectedStudentIds.includes(String(student.id)) && student.schoolday_managed);
  const hasSelectedManagedStudents = selectedManagedStudents.length > 0;

  return (
    <Container fluid className="ventris-content-wrapper ventris-students">
      <Header portal={sessionStorage.getItem("portal")!} page="students" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header align-items-center">
              <StudentPageIcon />
              <div className="flex-grow">{terms.students}</div>
              <Form.Control type="search" className="ventris-search" aria-label={`Search ${terms.students.toLowerCase()}`} placeholder={`Search ${terms.students.toLowerCase()}`} value={search} onChange={(event) => setSearch(event.target.value)} />
              <div className="d-flex gap-2">
                <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal" onClick={() => createStudent()} disabled={!canManageStudentsManually}><StudentIcon /> Add a {terms.student}</Button>
                <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal" onClick={() => openUploadStudents()} disabled={!canManageStudentsManually}>Upload {terms.students}</Button>
              </div>
            </h1>
            {organizationsLoaded && !canManageStudentsManually ? <div className="mb-3 text-muted">All accessible organizations are managed by SchoolDay, so {terms.students.toLowerCase()} must be managed by sync.</div> : null}
            <div className={showFilters ? '' : 'hidden'}>
              <OrganizationFilter updateFilter={updateFilter} organizations={organizations} />
            </div>
            <div className="flex flex-row">
              <div className="flex-grow">
                <Tabs defaultActiveKey="view-all" onSelect={(event) => handleTabChange(event)}>
                  <Tab eventKey="view-all" title="View All">
                  </Tab>
                  <Tab eventKey="active" title="Active">
                  </Tab>
                  <Tab eventKey="archived" title="Archived">
                  </Tab>
                </Tabs>
              </div>
              <div className="ventris-action-links">
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowArchiveModal(true)}><ArchiveIcon /> {archivedFilter === 'true' ? 'Unarchive' : 'Archive'} Selected</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowDeleteModal(true)} disabled={hasSelectedManagedStudents}><DeleteIcon /> Delete Selected</Button>
              </div>
            </div>
            {hasSelectedManagedStudents ? <div className="mb-2 text-muted">Selected {terms.students.toLowerCase()} in SchoolDay-managed organizations cannot be deleted manually.</div> : null}
            <ResponsiveTableRegion label={terms.students}>
              <BootstrapTable keyField='id' data={students} columns={columns} bordered={true} remote={{pagination: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} />
            </ResponsiveTableRegion>
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these item(s)? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => actuallyArchiveStudents()}>No, Archive Instead</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteStudents()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to {archivedFilter === 'true' ? 'unarchive' : 'archive'} these item(s)?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowArchiveModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyArchiveStudents()}>Yes, Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showEditModal} onHide={() => setShowEditModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="edit-student-title">
          <Offcanvas.Header className="offcanvas-header-purple" closeButton>
              <Offcanvas.Title id="edit-student-title">Edit {terms.student}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-student-form" validated={validatedEdit} ref={editFormRef} onSubmit={handleEditSubmit}>
                {errorEdit != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorEdit}
                </div> : null}
                <Form.Group className="mb-3" controlId="edit-student-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={availableManualOrganizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-student-first-name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="given-name" placeholder="First Name" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-student-last-name">
                    <Form.Label>Last Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="family-name" placeholder="Last Name" value={lastName} onChange={(event) => setLastName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-student-grade">
                    <Form.Label>Grade:</Form.Label>
                    <Form.Select required aria-label="Grade" value={grade} onChange={(event) => setGrade(event.target.value)}>
                      <option value="PK">PK</option>
                      <option value="K">K</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                      <option value="4th">4th</option>
                      <option value="5th">5th</option>
                      <option value="6th">6th</option>
                      <option value="7th">7th</option>
                      <option value="8th">8th</option>
                      <option value="9th">9th</option>
                      <option value="10th">10th</option>
                      <option value="11th">11th</option>
                      <option value="12th">12th</option>
                    </Form.Select>
                </Form.Group>
                <div className="default-grade-wrapper">
                  <input id="edit-student-default-grade" type="checkbox" checked={defaultGrade} onChange={(event) => setDefaultGrade(event.target.checked)} /> <label htmlFor="edit-student-default-grade">Set this grade as default for adding {terms.students.toLowerCase()}</label>
                </div>
                <Form.Group className="mb-3" controlId="edit-student-birthdate">
                    <Form.Label>Birthdate:</Form.Label>
                    <Form.Control required type="date" placeholder="Birthdate" value={birthdate} onChange={(event) => setBirthdate(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a birthdate.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="edit-student-code">
                    <Form.Label>{terms.student} Code:</Form.Label>
                    <Form.Control required type="text" placeholder={`${terms.student} Code`} value={studentCode} onChange={(event) => setStudentCode(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a {terms.student.toLowerCase()} code.</Form.Control.Feedback>
                </Form.Group>
                <br /><br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Save Changes</Button>
                <br />
                <Button type="submit" variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal full-width" onClick={() => setLaunchTestAfterSave(true)}>Save Changes + Launch Test</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showCreateModal} onHide={() => setShowCreateModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="create-student-title">
          <Offcanvas.Header className="offcanvas-header-purple" closeButton>
              <Offcanvas.Title id="create-student-title">Create {terms.student}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-student-form" validated={validatedCreate} ref={createFormRef} onSubmit={handleCreateSubmit}>
                {errorCreate != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorCreate}
                </div> : null}
                <Form.Group className="mb-3" controlId="create-student-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={availableManualOrganizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-student-first-name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="given-name" placeholder="First Name" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-student-last-name">
                    <Form.Label>Last Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="family-name" placeholder="Last Name" value={lastName} onChange={(event) => setLastName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-student-grade">
                    <Form.Label>Grade:</Form.Label>
                    <Form.Select required aria-label="Grade" value={grade} onChange={(event) => setGrade(event.target.value)}>
                      <option value="PK">PK</option>
                      <option value="K">K</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                      <option value="4th">4th</option>
                      <option value="5th">5th</option>
                      <option value="6th">6th</option>
                      <option value="7th">7th</option>
                      <option value="8th">8th</option>
                      <option value="9th">9th</option>
                      <option value="10th">10th</option>
                      <option value="11th">11th</option>
                      <option value="12th">12th</option>
                    </Form.Select>
                </Form.Group>
                <div className="default-grade-wrapper">
                  <input id="create-student-default-grade" type="checkbox" checked={defaultGrade} onChange={(event) => setDefaultGrade(event.target.checked)} /> <label htmlFor="create-student-default-grade">Set this grade as default for adding {terms.students.toLowerCase()}</label>
                </div>
                <Form.Group className="mb-3" controlId="create-student-birthdate">
                    <Form.Label>Birthdate:</Form.Label>
                    <Form.Control required type="date" placeholder="Birthdate" value={birthdate} onChange={(event) => setBirthdate(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a birthdate.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="create-student-code">
                    <Form.Label>{terms.student} Code:</Form.Label>
                    <Form.Control required type="text" placeholder={`${terms.student} Code`} value={studentCode} onChange={(event) => setStudentCode(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a {terms.student.toLowerCase()} code.</Form.Control.Feedback>
                </Form.Group>
                <br /><br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Add {terms.student}</Button>
                <br />
                <Button type="submit" variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal full-width" onClick={() => setLaunchTestAfterSave(true)}>Add {terms.student} + Launch Test</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showUploadModal} onHide={() => setShowUploadModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="upload-students-title">
          <Offcanvas.Header className="offcanvas-header-purple" closeButton>
              <Offcanvas.Title id="upload-students-title">Upload {terms.students}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-student-form" validated={validatedUpload} ref={uploadFormRef} onSubmit={handleUploadSubmit}>
                {errorUpload != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorUpload}
                </div> : null}
                {uploadSummary != "" ?
                <div className="mb-3">
                  {uploadSummary}
                </div> : null}
                <Form.Group className="mb-3" controlId="uploadOrganization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={availableManualOrganizations}
                      value={uploadOrganizationId}
                      onChange={setUploadOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="uploadCsvFile">
                    <Form.Label>CSV File:</Form.Label>
                    <Form.Control
                      required
                      type="file"
                      accept=".csv,text/csv"
                      onChange={(event: any) => setUploadFile(event.target.files && event.target.files[0] ? event.target.files[0] : null)}
                    />
                    <Form.Control.Feedback type="invalid">Please choose a CSV file.</Form.Control.Feedback>
                </Form.Group>
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Upload</Button>
                <br />
                <Button variant="link" className="ventris-action-link full-width" onClick={handleDownloadTemplate}>Download Template CSV</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showLaunchTest} onHide={() => setShowLaunchTest(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="students-launch-test-title">
          <Offcanvas.Header className="offcanvas-header-green" closeButton>
              <Offcanvas.Title id="students-launch-test-title">Launch a Test</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form.Group className="mb-3 ventris-form-element" controlId="test">
                <Form.Label>Test:</Form.Label>
                <Form.Select required aria-label="Test" value={test} onChange={(event) => setTest(event.target.value)}>
                  {launchableAssessmentsForUser(user).map((assessment) => <option key={assessment.name} value={assessment.schemaId}>{assessment.name}</option>)}
                </Form.Select>
            </Form.Group>
            <br /><br />
            <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" onClick={startNewTest}>Launch Test</Button>
          </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default ClinicianStudents;
